/** VM = vardiya müdürü, MD = mağaza müdürü (both staff_role = manager). */

export const MANAGER_KIND = {
  VM: 'vm',
  MD: 'md',
};

export function normalizeDutyKey(value) {
  return String(value || '')
    .trim()
    .toLocaleLowerCase('tr-TR')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function parseExcelDutyRole(label) {
  const key = normalizeDutyKey(label);
  if (!key) return null;
  if (key === 'vm' || key.includes('vardiya')) return MANAGER_KIND.VM;
  if (key === 'md' || key === 'mudur') return MANAGER_KIND.MD;
  if (key.includes('barista')) return 'barista';
  return null;
}

export function managerKindForStaff(member) {
  if (!member || member.staff_role !== 'manager') return null;
  return member.manager_kind === MANAGER_KIND.MD ? MANAGER_KIND.MD : MANAGER_KIND.VM;
}

export function isVardiyaMuduru(member) {
  return managerKindForStaff(member) === MANAGER_KIND.VM;
}

export function isMagazaMuduru(member) {
  return managerKindForStaff(member) === MANAGER_KIND.MD;
}

export function excelDutyLabelForStaff(member) {
  if (!member || member.staff_role !== 'manager') return 'Barista';
  return isMagazaMuduru(member) ? 'MD' : 'VM';
}

export function staffDisplayLabel(member) {
  if (!member) return '';
  if (member.staff_role === 'barista') return 'Barista';
  return isMagazaMuduru(member) ? 'Müdür (MD)' : 'Vardiya müdürü (VM)';
}

export function countsAsVardiyaMuduru({ member, excelDutyRole }) {
  if (excelDutyRole === MANAGER_KIND.VM) return true;
  if (excelDutyRole === MANAGER_KIND.MD || excelDutyRole === 'barista') return false;
  return isVardiyaMuduru(member);
}
